import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {SessionService} from '@q9elements/ui-kit/common';
import {
  DialogCloseButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';

import {LanguageSuggestionService} from '../../services/language-suggestion.service';

@Component({
  standalone: true,
  selector: 'q9ma-language-suggestion-dialog',
  templateUrl: './language-suggestion-dialog.component.html',
  styleUrls: ['./language-suggestion-dialog.component.scss'],
  imports: [
    DialogCloseButtonComponent,
    MatDialogModule,
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    TranslateModule
  ]
})
export class LanguageSuggestionDialogComponent implements OnInit {
  private dialogRef = inject(MatDialogRef<LanguageSuggestionDialogComponent>);
  private router = inject(Router);
  private sessionService = inject(SessionService);
  private languageSuggestionService = inject(LanguageSuggestionService);

  public data = inject<{browserLang: string}>(MAT_DIALOG_DATA);

  get suggestedLanguageTitle(): string {
    return this.languageSuggestionService.getLanguageTitle(this.data.browserLang);
  }

  ngOnInit() {
    this.languageSuggestionService.setLanguageProposalCookie();
  }

  onNavigateToProfile(): void {
    const teamIndex = this.sessionService.teamIndex();

    this.router.navigate(['/t', teamIndex, 'profile']);

    this.dialogRef.close(true);
  }

  onKeepCurrent(): void {
    this.dialogRef.close(false);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }
}
